import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 1EE03F8D-8B51-464B-84DE-6079644BA583
 * name checkbook-arrow-right
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbook-arrow-right.svg
 * tags
 * - Banking 
 */
export const CheckbookArrowRightIcon = createSvgIcon(<><path d="M5 14H15.53C15.25 14.31 15 14.64 14.8 15H5V14M21 8V12.08C21.72 12.2 22.39 12.45 23 12.8V5H1V19H14.08C14.03 18.68 14 18.34 14 18C14 17.66 14.03 17.33 14.08 17H3V8H21M5 10H12V12H5V10M24 18L21 15V17H17V19H21V21L24 18Z" /></>, 'CheckbookArrowRightIcon');
export default CheckbookArrowRightIcon